// src/app/services/base.service.ts
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { firstValueFrom } from 'rxjs'; // 👈 Agregado
import { UturuncoUtils } from 'src/app/utils/uturuncoUtils';

export abstract class BaseService<T> {
    protected api: string;
    protected other_header: HttpHeaders;

    constructor(
        protected http: HttpClient,
        protected endpoint: string
    ) {
        this.api = environment.wsdlUrl + endpoint;
    }

    protected getHeaders(): HttpHeaders {
        return UturuncoUtils.getHeader();
    }

    getList(page: number, limit: number): Promise<ApiResponse<T>> {
        this.other_header = this.getHeaders();
        return firstValueFrom(
            this.http.get<ApiResponse<T>>(`${this.api}?page=${page}&limit=${limit}`, {
                headers: this.other_header,
            })
        ).catch((error) => {
            console.error('Error en getList:', error);
            // Volvés a lanzar el error para que se propague
            throw error;
        });
    }

    getCriteria(criteria: any, page: number, limit: number): Promise<ApiResponse<T>> {
        this.other_header = this.getHeaders();
        return firstValueFrom(
            this.http.get<ApiResponse<T>>(`${this.api}/find/${criteria}?page=${page}&limit=${limit}`, {
                headers: this.other_header,
            })
        ).catch((error) => {
            console.error('Error en getCriteria:', error);
            // Volvés a lanzar el error para que se propague
            throw error;
        });
    }

    doFind(id: string | number): Promise<ApiResponse<T>> {
        this.other_header = this.getHeaders();
        return firstValueFrom(
            this.http.get<ApiResponse<T>>(`${this.api}/${id}`, {
                headers: this.other_header,
            })
        ).catch((error) => {
            console.error('Error en doFind:', error);
            // Volvés a lanzar el error para que se propague
            throw error;
        });
    }

    doInsert(evento: T): Promise<ApiResponse<T>> {
        this.other_header = this.getHeaders();
        return firstValueFrom(
            this.http.post<ApiResponse<T>>(this.api + '/', evento, {
                headers: this.other_header,
            })
        ).catch((error) => {
            console.error('Error en doInsert:', error);
            // Volvés a lanzar el error para que se propague
            throw error;
        });
    }

    doUpdate(evento: T, id: string | number): Promise<ApiResponse<T>> {
        this.other_header = this.getHeaders();
        return firstValueFrom(
            this.http.put<ApiResponse<T>>(`${this.api}/${id}`, evento, {
                headers: this.other_header,
            })
        ).catch((error) => {
            console.error('Error en doUpdate:', error);
            // Volvés a lanzar el error para que se propague
            throw error;
        });
    }

    doDelete(id: string | number): Promise<ApiResponse<T>> {
        this.other_header = this.getHeaders();
        return firstValueFrom(
            this.http.delete<ApiResponse<T>>(`${this.api}/${id}`, {
                headers: this.other_header,
            })
        ).catch((error) => {
            console.error('Error en doDelete:', error);
            // Volvés a lanzar el error para que se propague
            throw error;
        });
    }
}
export interface ApiResponse<T> {
    code: string;
    msg: string;
    data: T;
}